export const env = process.env.VUE_APP_WEB

export const config =  {
  local: {
    wechatFinderService: 'http://test-gateway.jinyi999.cn/invest-adviser-service/api/1/skynet',
    launcherService: 'http://test-gateway.jinyi999.cn',
    yintechService: 'http://test-gateway.jinyi999.cn',
    launcherService1: 'http://test-gateway.jinyi999.cn',
    behaviorUrl: 'http://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/add',
    socketUrl: 'http://test-online.jinyi999.cn?param=',
    wechat: {
      scope: 'snsapi_userinfo',
      state: '',
      defaultAvatar: require('../assets/wechat/default-avatar.png')
    },
    environConfig: {
      uri: 'http://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/spark/json/add',
      secret: `jX894Ui8YQom81Ss`,
      iv: `9985661470321659`
    },
    appDownloadUrl: 'http://test-jsapp.jinyi999.cn/rjhy/htz-app-h5/static/jfztqjb-download.html'
  },
  integration: {
    wechatFinderService: 'http://test-gateway.jinyi999.cn/invest-adviser-service/api/1/skynet',
    launcherService: 'http://test-gateway.jinyi999.cn',
    yintechService: 'http://test-gateway.jinyi999.cn',
    behaviorUrl: 'http://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/add',
    socketUrl: 'http://test-online.jinyi999.cn?param=',
    wechat: {
      scope: 'snsapi_userinfo',
      state: '',
      defaultAvatar: require('../assets/wechat/default-avatar.png')
    },
    environConfig: {
      uri: 'http://freegate-dev-k8s.qzg99.cn/api/user-behavior-service/api/1/behavior/spark/json/add',
      secret: `jX894Ui8YQom81Ss`,
      iv: `9985661470321659`
    },
    appDownloadUrl: 'http://test-jsapp.jinyi999.cn/rjhy/htz-app-h5/static/jfztqjb-download.html'
  },
  production: {
    launcherService1: 'https://gateway.jinyi999.cn',
    launcherService: 'https://gateway.jinyi999.cn',
    yintechService: 'https://gateway.techgp.cn',
    wechatFinderService: 'https://gateway.jinyi999.cn/invest-adviser-service/api/1/skynet',
    behaviorUrl: 'https://gateway.jinyi999.cn/rjhy-user-behavior/api/1/behavior/add',
    socketUrl: 'http://online.jinyi999.cn?param=',
    wechat: {
      scope: 'snsapi_userinfo',
      state: '',
      defaultAvatar: require('../assets/wechat/default-avatar.png')
    },
    environConfig: {
      uri: 'https://gateway.jinyi999.cn/rjhy-user-behavior/api/1/behavior/spark/json/add',
      secret: `jX894Ui8YQom81Ss`,
      iv: `9985661470321659`
    },
    appDownloadUrl: 'https://h5.techgp.cn/rjhy/htz-app-h5/static/jfztqjb-download.html'
  }
}[env]
